module.exports = __webpack_public_path__ + "static/puas_1-2-9fa367ac0c4855f5fd2c1e8d1ccdf002.png";